import React from 'react';
import Actions from 'components/DynamicTable/DynamicTableComponents/Editable/Actions';
import ActionEditIcon from 'resources/img/action-edit-icon.svg';
import ActionDeleteIcon from 'resources/img/action-delete-icon.svg';
import { ALERT_TYPES } from '@etiquette-ui/alert-dialog';
import { useAccess } from 'providers/access';
import { ACCESS_LIST } from 'resources/constants/config';

const RowActions = ({ item, state, globalState }) => {
  const { hasAccessInGroup } = useAccess();

  const actions = [
    {
      event: () => {
        globalState.config
          .alert({
            type: ALERT_TYPES.CONFIRM,
            config: {
              title: globalState.config.translate('Delete Permission'),
              body: globalState.config.translate('Are you sure you want to delete this permission?'),
              closeText: globalState.config.translate('Go Back'),
              submitText: globalState.config.translate('Delete'),
            },
          })
          .then(() => {
            globalState.config.dispatcher.deleteStart({ id: +item.id, groupId: +item.groupId });
          })
          .catch(() => {});
      },
      src: ActionDeleteIcon,
      disabled: !hasAccessInGroup(+item.groupId, ACCESS_LIST.PERMISSION),
    },
    {
      event: () => globalState.config.history.push(`/${item.groupId}/management/permissions/edit/${item.id}`),
      src: ActionEditIcon,
      disabled: !hasAccessInGroup(+item.groupId, ACCESS_LIST.PERMISSION),
    }
  ];

  return <Actions loading={globalState.config.data.fetching?.config?.id == item.id} actions={actions} />;
};

export default RowActions;
